import {SCHOOL_STAFF_ENDPOINT,} from "../../utils/constants";
import {BaseSearchBox} from "../search-box";
import {StaffSortFilters} from "../../utils/constants-types";

export const StaffSearch = (
    {
        data,
        setData,
        setIsLoading,
        payload
    }
) => {

    return BaseSearchBox({
        placeholder: "Enter name, phone or ID/TSC No...",
        endpoint: SCHOOL_STAFF_ENDPOINT,
        data: data,
        setData: setData,
        setIsLoading: setIsLoading,
        payload: payload,
        sortFilters: StaffSortFilters,
    });
};
